import React, { useState, useRef } from 'react';
import { ReactComponent as EditIcon } from 'components/icons/edit.svg';
import { SelectList } from 'components/ui/SelectList/SelectList';
import { ReactComponent as ExpandIcon } from 'components/icons/down.svg';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import { NotesWrapper, Placeholder, PlaceholderText, StyledTextarea, Suggestion, TextareaWrapper } from './NotesStyles';

interface IProps {
  value: string | undefined;
  onChangeCallback: (note: string) => void;
  onFocusIn: () => void;
  onFocusOut: () => void;
  disabled?: boolean;
  suggestions?: string[];
}

const Notes: React.FC<IProps> = ({ value, onChangeCallback, disabled, onFocusIn, onFocusOut, suggestions }) => {
  const [suggestionsVisible, setSuggestionsVisible] = useState<boolean>(false);
  const [placeholderVisible, setPlaceholderVisible] = useState<boolean>(false);
  const iconRef = useRef<any>();
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  useOnClickOutside(
    iconRef,
    () => {
      setSuggestionsVisible(false);
    },
    'click'
  );

  const hidePlaceholder = () => {
    if (disabled) {
      return;
    }
    setPlaceholderVisible(true);
    if (textareaRef.current) {
      textareaRef.current.focus();
    }
  };

  const handleOnBlurTextarea = () => {
    setPlaceholderVisible(false);
    onFocusOut();
  };

  const getValue = () => {
    if (!value) {
      return `Add a note to this pitch${suggestions ? ', or pick from a list' : ''}`;
    }
    return value;
  };

  return (
    <NotesWrapper className={`${disabled ? ' disabled' : ''}`}>
      <EditIcon />
      <TextareaWrapper>
        <StyledTextarea
          maxLength={80}
          value={value}
          onChange={(e) => onChangeCallback(e.target.value)}
          onFocus={() => onFocusIn()}
          onBlur={handleOnBlurTextarea}
          ref={textareaRef}
        />
        {!placeholderVisible && (
          <Placeholder onClick={hidePlaceholder}>
            <PlaceholderText>
              <span className={value === '' ? 'grey' : ''}>{getValue()}</span>
            </PlaceholderText>
          </Placeholder>
        )}
      </TextareaWrapper>
      {suggestions && (
        <>
          <ExpandIcon
            className='expand-icon'
            ref={iconRef}
            onClick={() => {
              !disabled && setSuggestionsVisible(!suggestionsVisible);
            }}
          />
          <SelectList visible={suggestionsVisible}>
            {suggestions.map((s, index) => {
              return (
                <Suggestion key={index} onClick={(e) => onChangeCallback(e.currentTarget.textContent!)}>
                  {s}
                </Suggestion>
              );
            })}
          </SelectList>
        </>
      )}
    </NotesWrapper>
  );
};

export default Notes;
